"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkDeletedSubDocumentChange = void 0;
var enums_1 = require("../../enums");
var BookmarkDeletedSubDocumentChange = (function () {
    function BookmarkDeletedSubDocumentChange(subDocumentId, bkmTempate, deleted) {
        if (deleted === void 0) { deleted = false; }
        this.subDocumentId = subDocumentId;
        this.bkmTempate = bkmTempate;
        this.deleted = deleted;
        this.type = enums_1.ModelChangeType.BookmarkDeleted;
    }
    BookmarkDeletedSubDocumentChange.prototype.toJSON = function (_withPostData) {
        return this.deleted ?
            [[this.bkmTempate.name]] :
            [[this.bkmTempate.name, this.bkmTempate.start, this.bkmTempate.end]];
    };
    return BookmarkDeletedSubDocumentChange;
}());
exports.BookmarkDeletedSubDocumentChange = BookmarkDeletedSubDocumentChange;
